export const SUBTITLE_SIZES = ['m', 'l', 'xl'];
export const SUBTITLE_THEMES = ['bw'];
